
import Vue from 'vue'
import bus from './bus'

import router from '@/router/index.js'
//ajax错误处理
export const catchError = function (error) {
  if (error) {
    switch (error.status) {
      case 400:
        Vue.prototype.$notify({
          message: error.data.message  || '请求参数异常',
          duration: 1000,
          background: '#FF0000'
        })
        break
      case 401:   //token失效
        localStorage.removeItem('token')
        setTimeout(() => {
          // window.location.href = window.location.href
          Vue.prototype.$notify({
            message: error.data.message ,
            duration: 1500,
            background: '#FF0000'
          })
          // Vue.$message.error(error.data.message)
          // bus.$emit('token_ex')
        }, 500)
        break
        case 500:   //token失效
        Vue.prototype.$notify({
          message: error.data.message  || '服务端异常，请联系技术支持',
          background: '#FF0000'
        })
        break
        case 1500:   //token失效
        Vue.prototype.$notify({
          message: error.data.message  || '服务端异常，请联系技术支持',
          background: '#FF0000'
        })
        router.push('/login')
        break
      default:
        // Vue.prototype.$notify({
        //   message: error.data.message  || '服务端异常，请联系技术支持',
        //   background: '#FF0000'
        // })
    }
  }
  //return Promise.reject(error)
}

export const getDeptTreeData = function(data,pId = 0){    //序列化菜单树形结构
  const temp = [];
  for (const item of data) {
    if (item.pId === pId && item.id != 0) {
      let children = getDeptTreeData(data, item.id);
      if (children.length > 0) {
        item.children = children;
      }
      temp.push(item);
    }
  }
  return temp;
}



export const filterDeptTreeByTierIndex = function(treeData, tierIndex) {  // 根据层级过滤部门树形结构
  if(treeData.length == 0) return []
  let filter = (treeData) => {
    treeData.forEach(item => {
      if(!(item.children != undefined && item.children.length !=0)) return
      // 只显示前3层
      if(item.tierIndex >= tierIndex ) item.children = []
      filter(item.children)
    })
  }
  filter(treeData)
  return treeData
}

export const getMenuTreeData = function(data,pId = 0){    //序列化菜单树形结构
  const temp = [];
  for (const item of data) {
    if (item.pId === pId && item.id != 0) {
      item.children = getMenuTreeData(data,item.id);
      temp.push(item);
    }
  }
  return temp;
}

export const getDictTreeData = function(data,pId = 0){    //序列化字典树形结构
  const temp = [];
  for (const item of data) {
    if (item.pId === pId && item.id != 0) {
      item.children = getMenuTreeData(data,item.id);
      temp.push(item);
    }
  }
  return temp;
}

export const getMenuTreeDataByLevel = function(data,pCode = "0"){    //序列化菜单树形结构
  const temp = [];
  for (const item of data) {
    // item.id = item.menuId
    if (item.pCode === pCode) {
      item.children = getMenuTreeDataByLevel(data,item.code);
      temp.push(item);
    }
  }
  return temp;
}

export const exportToExcel = function(columns,list,title){
  require.ensure([], () => {
    const { export_json_to_excel } = require('../excel/Export2Excel');
    let tHeader = []
    let filterVal = []
    columns.forEach(item =>{
        tHeader.push(item.title)
        filterVal.push(item.key)
    })
    const data = list.map(v => filterVal.map(j => v[j]))
    export_json_to_excel(tHeader, data, title);
  })
}

//递归函数，pid默认0为根节点
export function buildTree(items, pid = 0) {
  //查找pid子节点
  let pitems = items.filter(s => s.pid === pid)
  if (!pitems || pitems.length <= 0)  return null
  //递归
  pitems.forEach(item => {
    const res = buildTree(items, item.tagId)
    if (res && res.length > 0)
      item.children = res
  })
  return pitems
}

export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}



// WEBPACK FOOTER //
// ./src/utils/util.js